<template>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ component.name }} <span v-if="component.type">({{ component.type }})</span></h4>
    </div>
    <div class="modal-body">
      <div class="row">   
        <div class="col-md-12">
          <div class="form-group">
            <label for="name">{{ _('Name') }}</label><br />
            <input type="text" class="form-control" v-model="component.name" />
          </div>
        </div>
      </div>
      <div v-if="componentEditorType">
        <component v-if="componentEditorType" 
                  :is="componentEditorType" 
                  :sourceComponent="component" 
                  v-on:setData="setData"></component>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-default" v-on:click="hideModal"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
      <button class="btn btn-warning" v-on:click="unlinkComponent"><i class="fa fa-fw fa-chain-broken"></i> {{ _('Remove from layout') }}</button>
      <button class="btn btn-success" v-on:click="saveComponent"><i class="fa fa-fw fa-save"></i> {{ _('Save') }}</button>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      component: { ...this.sourceComponent } // Make a copy of the component so we can make changes
    }
  },
  props: ['sourceComponent'],
  computed: {
    componentEditorType () {
      if (!this.component || !this.component.type) {
        return false
      }
      /*
      switch (this.component.type) {
        case 'ProductReservationSchedule':
          return this.component.type + 'Editor'
      }
      */
      return false
    }
  },
  methods: {
    hideModal () {
      this.$emit('close')
    },
    saveComponent () {
      this.$emit('saveComponent', this.component)
    },
    unlinkComponent () {
      this.$emit('unlinkComponent', this.component.id)
    },
    setData (data) {
      this.component.data = data
    }
  }
}
</script>